import { GameConfigService, VarsService } from '~/rage/services';
import { IObservable, SeenTracker, Subject } from '~/rage/utils';
import { HelpModalConfig, IHelpModalService } from './helpModalServiceTypes';

export class HelpModalService implements IHelpModalService {
	private activeModal = new Subject<HelpModalConfig | null>(null);
	private modalsById = new Subject<Record<string, HelpModalConfig> | null>(
		null,
	);
	private seenTracker = new SeenTracker('helpModals');

	constructor(
		private readonly vars: VarsService,
		private readonly gameConfig: GameConfigService,
	) {
		this.gameConfig.getConfigs().subscribe((config) => {
			if (!config || !config.helpModals) {
				return;
			}

			this.modalsById.next(config.helpModals.modalsById);
		});

		this.vars
			.get<string | null>('helpModals:activeModalId', null)
			.subscribe(this.handleCurrentModalUpdate.bind(this));
	}

	private handleCurrentModalUpdate(modalId: string | null): void {
		const modalsById = this.modalsById.getValue();
		if (!modalId || !modalsById) {
			this.activeModal.next(null);
			return;
		}

		if (this.isUnseen(modalId)) {
			this.activeModal.next(modalsById[modalId] ?? null);
		} else {
			this.activeModal.next(null);
		}
	}

	public getActiveModal(): IObservable<HelpModalConfig | null> {
		return this.activeModal;
	}

	public async replyToHelpModal(dontShowAgain: boolean): Promise<void> {
		if (dontShowAgain) {
			const activeModal = this.activeModal.getValue();
			if (activeModal) {
				this.maskSeen(activeModal.id);
			}
		}

		this.activeModal.next(null);
	}

	public isUnseen(modalId: string): boolean {
		return this.seenTracker.isUnseen(modalId);
	}

	public maskSeen(modalId: string): void {
		this.seenTracker.markAsSeen(modalId);
	}
}
